import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { UserCountersEntity } from '@interpals/api-web';

import api from 'api';

export const getUserCounters = createAsyncThunk('counters/get', async () => {
    return await api.getUserCounters();
});

export const updateCounters = createAction<UserCountersEntity>('ws/counters/update');
export const updateNewMessagesCount = createAction<number>('counters/update/newMessagesCount');
